import { render } from "./blog_details_left_sidebar.vue?vue&type=template&id=54a24dce"
import script from "./blog_details_left_sidebar.vue?vue&type=script&lang=js"
export * from "./blog_details_left_sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__